import { render, staticRenderFns } from "./ysHome.vue?vue&type=template&id=1b6ca1c0&scoped=true&"
import script from "./ysHome.vue?vue&type=script&lang=js&"
export * from "./ysHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6ca1c0",
  null
  
)

export default component.exports